// Шрифт Inter self-hosted: латиница и вьетнамский — интерфейс живёт на трёх
// локалях, и подгружать шрифт со стороннего CDN на рабочем инструменте незачем.
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'

// Моноширинный из макетов — ключи задач, номера прогонов, сроки и ⌘K. Без него
// токен `--font-family-mono` доезжает до системного monospace: на macOS это
// Menlo, и DEV-1465 в нём заметно шире, чем в макете.
import '@fontsource/jetbrains-mono/400.css'
import '@fontsource/jetbrains-mono/500.css'

// Стили floating-vue: на них стоят поповеры пакета — AppDatePicker,
// AppTimePicker, AppDropdown. Без этого файла у `.v-popper__popper` нет ни
// `z-index: 10000`, ни `top/left: 0`: панель уезжает мимо экрана и ложится под
// модалку (DEV-2105). Пакет их не тянет сам — floating-vue у него peer.
import 'floating-vue/dist/style.css'
import '@vinprop/design-system/styles.css'
import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { setupTheme } from '@vinprop/design-system'

import App from './App.vue'
import router from './router'
import { i18n } from './i18n'

// Тему ведёт пакет: атрибут data-theme и подписка на системную при AUTO.
// Хранение — отдельный ключ трекера, чтобы не делить localStorage с CRM.
setupTheme({
  initial: (localStorage.getItem('tracker-theme') as 'light' | 'dark' | 'auto' | null) ?? 'auto',
  persist: (theme) => localStorage.setItem('tracker-theme', theme),
})

createApp(App).use(createPinia()).use(router).use(i18n).mount('#app')
